// extracted by mini-css-extract-plugin
export default {"Badge":"ApiKeys_Badge__W3gzc","text":"ApiKeys_text__PeO4x","error":"ApiKeys_error__WEI2S"};